const safeName = (s) => String(s).replace(/[\\/:*?"<>|]+/g, "-").trim();

// Print size for the 6x4 in Protocol / Saree cards, chosen per PC (Print size selector or counter setup).
export const PRINT_SIZES = [
  { key: "s21x15", label: "150 x 210 mm sheet, portrait - Devotee copy, then Office copy (next page)" },
  { key: "a5", label: "Half A4 sheet (A5) - Devotee copy, then Office copy" },
  { key: "half", label: "Full A4 sheet - Devotee copy on page 1, Office copy on page 2 (both at the top)" },
  { key: "a4", label: "A4 sheet (portrait) - devotee + office copy on one page" },
  { key: "4x6", label: "6 x 4 in card (portrait)" },
  { key: "card", label: "6 x 4 in card (landscape)" },
  { key: "rot", label: "6 x 4 in card (landscape design, portrait paper)" },
  { key: "slip", label: "Thermal slip (80 mm roll) - like Annaprasadam" },
];
export const getPrintSize = () => {
  try { return PRINT_SIZES.some((p) => p.key === localStorage.getItem("pd_print_paper")) ? localStorage.getItem("pd_print_paper") : "s21x15"; } catch { return "s21x15"; }
};
export const setPrintSize = (key) => {
  try { localStorage.setItem("pd_print_paper", key); } catch { /* storage unavailable */ }
  window.dispatchEvent(new CustomEvent("pd-print-size", { detail: key })); // cards on screen switch layout
};

// Print colours for the Protocol / Saree tickets: "light" (default, clear on paper) or "full" (as designed).
export const getPrintColors = () => {
  try { return localStorage.getItem("pd_print_colors") === "full" ? "full" : "light"; } catch { return "light"; }
};
export const setPrintColors = (v) => {
  try { localStorage.setItem("pd_print_colors", v); } catch { /* storage unavailable */ }
  window.dispatchEvent(new CustomEvent("pd-print-colors", { detail: v }));
};

// Per-PC print position for the cards: move (mm) and size (%) so the print starts where the paper starts.
export const ADJUST_DEFAULT = { x: 0, y: 0, s: 97 };
export const getPrintAdjust = () => {
  try { return { ...ADJUST_DEFAULT, ...JSON.parse(localStorage.getItem("pd_print_adjust") || "{}") }; } catch { return { ...ADJUST_DEFAULT }; }
};
export const setPrintAdjust = (a) => {
  try { localStorage.setItem("pd_print_adjust", JSON.stringify(a)); } catch { /* storage unavailable */ }
  window.dispatchEvent(new CustomEvent("pd-print-adjust", { detail: a }));
};

// Re-arrange the cards for the chosen paper: A4 = two cards per sheet; portrait = one portrait card per page;
// rot = each landscape card turned onto its own portrait page.
function layoutCards(portal, size) {
  const cards = [...portal.querySelectorAll(".print-area")];
  if (!cards.length) return;
  portal.innerHTML = "";
  if (size === "half") {
    // One half-A4 ticket per A4 page, always in the upper half (Devotee copy page 1, Office copy page 2, same place),
    // with a cut guide across the middle of the page.
    cards.forEach((c) => {
      const sheet = document.createElement("div");
      sheet.className = "half-sheet";
      const cut = document.createElement("div");
      cut.className = "cut-v";
      sheet.appendChild(c); sheet.appendChild(cut);
      portal.appendChild(sheet);
    });
  } else if (size === "a4") {
    for (let i = 0; i < cards.length; i += 2) {
      const sheet = document.createElement("div");
      sheet.className = "a4-sheet";
      cards.slice(i, i + 2).forEach((c, j) => {
        if (j) { const cut = document.createElement("div"); cut.className = "cut-line"; sheet.appendChild(cut); }
        sheet.appendChild(c);
      });
      portal.appendChild(sheet);
    }
  } else {
    cards.forEach((c) => {
      if (size === "s21x15") { const w = document.createElement("div"); w.className = "sheet-2115"; w.appendChild(c); portal.appendChild(w); return; }
      if (size !== "rot") { portal.appendChild(c); return; }
      const w = document.createElement("div"); w.className = "rot-wrap"; w.appendChild(c); portal.appendChild(w);
    });
  }
}

// title: suggested file name when the print is saved as PDF (Chrome uses the page title).
export function printHtml(html, pageClass, title) {
  const cardSize = pageClass === "ticket-page" ? getPrintSize() : null;
  if (cardSize === "a5") pageClass = "ticket-a5-page";
  if (cardSize === "s21x15") pageClass = "ticket-2115-page";
  if (cardSize === "half") pageClass = "ticket-half-page";
  if (cardSize === "a4") pageClass = "ticket-a4-page";
  if (cardSize === "4x6") pageClass = "ticket-4x6-page";
  if (cardSize === "rot") pageClass = "ticket-rot-page";
  if (cardSize === "slip") pageClass = "receipt-page";
  const oldTitle = document.title;
  if (title) {
    document.title = safeName(title);
    const restore = () => { document.title = oldTitle; window.removeEventListener("afterprint", restore); };
    window.addEventListener("afterprint", restore);
    setTimeout(restore, 120000); // fallback if afterprint never fires
  }
  let portal = document.getElementById("print-portal");
  if (!portal) {
    portal = document.createElement("div");
    portal.id = "print-portal";
    document.body.appendChild(portal);
  }
  portal.className = pageClass;
  portal.innerHTML = html;
  const lightPrint = !!portal.querySelector(".print-light"); // keep "Light - for paper" colours after re-layout
  if (["a5", "s21x15", "half", "a4", "4x6", "rot", "slip"].includes(cardSize)) layoutCards(portal, cardSize);
  if (lightPrint) portal.classList.add("print-light");
  portal.style.removeProperty("--pa-x"); portal.style.removeProperty("--pa-y"); portal.style.removeProperty("--pa-s");
  if (cardSize && cardSize !== "slip") {
    const a = getPrintAdjust();
    portal.style.setProperty("--pa-x", `${Number(a.x) || 0}mm`);
    portal.style.setProperty("--pa-y", `${Number(a.y) || 0}mm`);
    if (!["a4", "half", "a5", "s21x15"].includes(cardSize) || Number(a.s) !== ADJUST_DEFAULT.s) portal.style.setProperty("--pa-s", String((Number(a.s) || ADJUST_DEFAULT.s) / 100));
  }
  document.body.classList.add("printing");
  setTimeout(() => {
    window.print();
    document.body.classList.remove("printing");
    portal.innerHTML = "";
  }, 60);
}
